<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <div class="left">
          <div class="title">
            <span class="count">{{selected.length}}</span>
            <span class="category">{{category}}</span>
            <span class="seprate">-</span>
            <span class="name">{{title}}</span>
          </div>
          <div class="selectInputer">
            <img src="../assets/img/interview/search.svg" alt="search" class="search">
            <input class="enter" type="text" :placeholder="`请输入要查找的${category}`" v-model="filter" @keyup="filterOptions()">
          </div>
        </div>
        <img src="../assets/img/resources/close.svg" alt="close" class="close" @click="cancel()">
      </div>
      <div class="selected">
        <span class="title">已选：</span>
        <div class="items">
          <span class="item" v-for="(s, i) in selected" :key="i">
            <span class="name">
              {{s.title}}
            </span>
            <img src="../assets/img/resources/delete.svg" alt="delete" class="del" @click="deleteSelect(s)">
          </span>
          <p class="add" v-if="categoryId - 0 !== 8 && showAdd">
            <span>新增：</span>
            <span class="enter" @keyup.enter="peopleAdded()">
              <input type="text" v-model="temporaryName" placeholder="">
              <span class="cfm" @click="peopleAdded()">确定</span>
            </span>
          </p>
        </div>
        <div v-show="categoryId == 7" :class="{cameraType: true, active: cameraType.active, hasType: cameraType.selected.id != 0}" @click.stop="cameraType.toggle()">
          <div class="title">
            <span>
              {{cameraType.selected.title}}
            </span>
            <div class="list" v-show="cameraType.active">
              <p class="item" v-for="(i, d) in cameraType.list" :key="d" @mousedown="cameraType.selectItem(i)">
                {{i.title}}
              </p>
            </div>
          </div>
          <img :src="cameraType.active ? cameraType.icons.up : cameraType.icons.down" alt="icon">
        </div>
      </div>
      <div class="container">
        <empty :msg="'暂无数据'" v-if="options.length === 0" />
        <div class="item" v-for="(i, d) in options" :key="d" @click="selectItem(i)" v-show="!i.hide">
          <img :src="i.selected ? icons.checkerOn : icons.checker" alt="checker" class="checker">
          <span class="busy" v-if="i.status - 0 === 2">忙</span>
          <span class="empty" v-if="i.status - 0 === 3">休</span>
          <span :class="{name: true, green: i.selected}">
            <span v-if="i.person_type - 0 === 1" class="temporary">(临)</span>
            <span>{{i.title}}</span>
          </span>
        </div>
      </div>
      <div class="footline">
        <div class="btn" @click="clearSelect()">
          清空
        </div>
        <div class="right">
          <div :class="{btn: true, add: true, greenBtn: showAdd}" @click="toggleShowAdd()" v-show="categoryId - 0 !== 8">
            新增
          </div>
          <div class="btn greenBtn" @click="setResource()">
            保存
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'resourceHandles',
  components: {
    empty
  },
  data() {
    return {
      show: false,
      icons: {
        checker: require('../assets/img/interview/checker.svg'),
        checkerOn: require('../assets/img/interview/checkerOn.svg')
      },
      selected: [],
      title: '标题',
      category: '类型',
      categoryId: null,
      options: [],
      interviewId: null,
      temporaryName: '',
      filter: '',
      showAdd: false,
      handlePromise: null,
      handleResolve: null,
      originData: {},
      cameraType: {
        // 摄像类型选择下拉窗
        active: false,
        icons: {
          up: require('@assets/img/common/upward.svg'),
          down: require('@assets/img/common/xiala.svg')
        },
        selected: {
          id: 0,
          title: '类型'
        },
        list: [],
        toggle: () => {
          this.cameraType.active = !this.cameraType.active
        },
        selectItem: (i) => {
          this.cameraType.selected = i
        }
      }
    }
  },
  methods: {
    toggleShowAdd() {
      // 切换显示“新增”
      this.showAdd = !this.showAdd
    },
    cancel() {
      // 取消操作，关闭弹窗
      if (this.handleResolve) {
        this.handleResolve(false)
        this.handlePromise = null
      }

      this.close()
    },
    close() {
      // 关闭弹窗
      this.show = false
    },
    setResource() {
      // 分配资源
      if (this.categoryId == 6) {
        this.setDriverAndBus()
        return
      }

      const ids = []
      this.options.forEach(i => {
        if (i.selected) {
          ids.push(i.id)
        }
      })

      const info = {
        iview_id: this.interviewId,
        resource_id: ids.join(','),
        type_id: this.categoryId,
        iview_type: this.cameraType.selected.id
      }

      common.myFetch(apis.Res_resource_set, info)
      .then((data) => {
        if (data) {
          this.$toast(data)

          this.handleResolve(true)
          this.close()
        }
      })
    },
    setDriverAndBus() {
      // 同时设定司机和采访车
      const originBuses = this.originData.cars.list
      const drivers = []
      const buses = []
      originBuses.forEach((b) => {
        buses.push(b.id)
      })

      this.options.forEach(i => {
        if (i.selected) {
          drivers.push(i.id)
          if (i.device_id != 0) {
            buses.push(i.device_id)
          }
        }
      })

      const driverInfo = {
        iview_id: this.interviewId,
        resource_id: drivers.join(','),
        type_id: this.categoryId
      }

      const busInfo = {
        iview_id: this.interviewId,
        resource_id: buses.join(','),
        type_id: 8
      }

      const fetchDriver = common.myFetch(apis.Res_resource_set, driverInfo)
      const fetchBus = common.myFetch(apis.Res_resource_set, busInfo)
      Promise.all([fetchDriver, fetchBus]).then(() => {
        this.$toast('操作成功')

        this.handleResolve(true)
        this.close()
      })
    },
    filterOptions() {
      // 筛选过滤
      this.options.forEach((i) => {
        this.$set(i, 'hide', true)
      })

      this.options.forEach((i) => {
        if (i.title.indexOf(this.filter) > -1) {
          this.$set(i, 'hide', false)
        }
      })
    },
    addPeople() {
      // 添加临时人员
      if (!this.temporaryName) {
        this.$toast('请输入名字')
        return
      }

      const info = {
        title: this.temporaryName,
        class_id: '2',
        class_title: '基本类',
        type_id: this.categoryId,
        type_title: this.category
      }

      return common.myFetch(apis.Res_temporarypeople_add, info)
      .then((data) => {
        if (data) {
          this.$toast('添加成功')
          this.temporaryName = ''
          return data.person_id
        }
      })
    },
    async peopleAdded() {
      // 添加人员后默认选中
      const newId = await this.addPeople()
      this.options = await this.getRoster()
      this.options.forEach((i) => {
        if (i.id - 0 === newId) {
          // this.$set(i, 'selected', true)
          // this.calculateSelects()
          this.selected.push(i)
        }

        this.selected.forEach(s => {
          if (s.id === i.id) {
            this.$set(i, 'selected', true)
          }
        })
      })


    },
    open(info) {
      // 打开弹窗，调用方法获取数据，传入已选项
      this.title = info.title
      this.category = info.type
      this.interviewId = info.interviewId
      this.categoryId = info.typeId
      this.originData = info.origin
      this.getOptions()
      .then(() => {
        info.list.forEach((s) => {
          this.options.forEach((o) => {
            if (s.id == o.id) {
              this.$set(o, 'selected', true)
            }
          })
        })

        this.calculateSelects()
      })
      this.show = true

      this.handlePromise = new Promise((resolve) => {
        this.handleResolve = resolve
      })

      return this.handlePromise
    },
    async selectItem(i) {
      // 选择
      if (!i.selected) {
        if (i.status == 3) {
          const msg = `${i.title}正在休假，确认分配任务?`
          const c = await this.$confirm(msg)
          if (!c) return
        }
      }

      this.$set(i, 'selected', !i.selected)
      this.calculateSelects()
    },
    async getOptions() {
      // 获取待选列表
      let options = []
      if (this.categoryId - 0 === 8) {
        options = await this.getBus()
      } else {
        options = await this.getRoster()
      }

      this.options = options
    },
    getBus() {
      // 获取采访车
      const info = {
        iview_id: this.interviewId
      }

      return common.myFetch(apis.Res_bus_list, info)
      .then((data) => {
        return data.list
      })
    },
    getRoster() {
      // 获取人员
      const info = {
        type_id: this.categoryId,
        iview_id: this.interviewId
      }

      return common.myFetch(apis.Res_roster_list, info)
      .then((data) => {
        if (this.categoryId == 7) {
          // 如果是摄像
          this.cameraType.list = data.type_list

          this.cameraType.list.forEach(i => {
            if (i.selected) {
              this.cameraType.selected = i
            }
          })
        }

        return data.list
      })
    },
    calculateSelects() {
      // 检查所有selected为true的选项，插入到selected数组中
      this.selected = []
      this.$nextTick(() => {
        this.options.forEach((i) => {
          if (i.selected) {
            this.selected.push(i)
          }
        })
      })
    },
    deleteSelect(i) {
      // 反选
      this.$set(i, 'selected', false)
      this.calculateSelects()
    },
    clearSelect() {
      // 反选所有
      this.options.forEach((i) => {
        // i.selected = false
        this.$set(i, 'selected', false)
      })
      this.calculateSelects()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1111;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 680px;
    height: 514px;
    padding:6px 30px 0;
    display: flex;
    flex-direction: column;
    .headline {
      height: 62px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #dcdcdc;
      .left {
        width: 552px;
        display: flex;
        align-items: center;
      }
      .title {
        width: 272px;
        color: @dark;
        font-size: 24px;
        display: flex;
        align-items: center;
        .count {
          font-size: 14px;
          width: 22px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          color: #fff;
          background-color: @sub;
          border-radius: 100%;
          margin-right: 6px;
        }
        .seprate {
          margin: 0 4px;
        }
        .name {
          flex: 1;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .selectInputer {
        width: 280px;
        height: 40px;
        border-radius: 100px;
        background:rgba(185, 195, 195, 0.20);
        margin-left: 20px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        .enter {
          flex: 1;
          color: @dark;
          font-size: 14px;
          background-color: transparent;
          &::placeholder {
            color: @dateColor;
            font-size: 14px;
          }
        }
        .search {
          cursor: pointer;
          margin-right: 10px;
        }
      }
      .close {
        cursor: pointer;
      }
    }
    .selected {
      height: auto;
      display: flex;
      align-items: flex-start;
      min-height: 70px;
      padding: 20px 0;
      border-bottom: 1px solid #dcdcdc;
      .title {
        font-size: 14px;
        color: @sub;
        margin-right: 10px;
        height: 30px;
        line-height: 30px;
      }
      .items {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -10px;
        .item {
          background-color: rgba(185, 195, 195, 0.2);
          border-radius: 4px;
          min-width: 76px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          color: @dark;
          font-size: 14px;
          margin-right: 16px;
          margin-bottom: 10px;
          .del {
            margin-left: 6px;
            cursor: pointer;
          }
        }
        .add {
          height: 30px;
          font-size: 13px;
          color: @sub;
          display: flex;
          align-items: center;
          .enter {
            margin-left: 10px;
            width: 120px;
            height: 30px;
            border-radius: 4px;
            background-color: rgba(185, 195, 195, 0.2);
            padding: 0 6px;
            display: flex;
            align-items: center;
            input {
              font-size: 14px;
              color: @dark;
              width: 100%;
              flex: 1;
              height: 100%;
              padding-right: 6px;
              background-color: transparent;
            }
            .cfm {
              cursor: pointer;
              flex-shrink: 0;
              color: @green;
            }
          }
        }
      }
      .cameraType {
        cursor: pointer;
        width: 90px;
        height: 30px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .title {
          flex: 1;
          position: relative;
          .list {
            .boxOuter;
            position: absolute;
            width: 90px;
            height: 240px;
            border-radius: 4px;
            overflow-y: auto;
            background-color: #fff;
            margin: 10px 0 0 -12px;
            .item {
              height: 30px;
              line-height: 30px;
              padding: 0 12px;
              display: flex;
              cursor: pointer;
              color: @dark;
              &:hover {
                background:rgba(65,180,140,0.15);
              }
            }
          }
        }
      }
      .hasType {
        .title {
          color: @dark;
        }
      }
    }
    .container {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .item {
        min-width: 130px;
        height: 20px;
        margin: 20px 30px 20px 0;
        display: flex;
        align-items: center;
        cursor: pointer;
        .green {
          color: @green;
        }
        .name {
          font-size: 16px;
          margin-left: 10px;
          word-break: keep-all;
          .temporary {
            margin-right: 6px;
          }
        }
        .busy {
          margin-left: 4px;
          font-size: 13px;
          width: 20px;
          height: 20px;
          background-color: @redBg;
          color: @redFont;
          border-radius: 4px;
          text-align: center;
          line-height: 20px;
        }
        .empty {
          margin-left: 4px;
          font-size: 13px;
          width: 20px;
          height: 20px;
          background-color: @ylBg;
          color: @ylFont;
          border-radius: 4px;
          text-align: center;
          line-height: 20px;
        }
      }
      // .item:nth-child(3n) {
      //   margin-right: 0;
      // }
    }
    .footline {
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        background-color: @dateColor;
        color: #fff;
        border-radius: 100px;
        cursor: pointer;
        &:active {
          .btnActive;
        }
        &:hover {
          .btnHover;
        }
      }
      .greenBtn {
        background-color: @green;
      }
      .add {
        margin-right: 20px;
      }
      .right {
        height: 40px;
        width: 260px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
